export const CONTROLLERS = {
  sites: 'api/sites',
  tasks: 'api/tasks',
  scacs: 'api/scacs',
  trailers: 'api/trailers',
  yardAudits: 'api/yard-audits',
  companies: 'api/companies',
  users: 'api/users',
  roles: 'api/roles',
  contacts: 'api/contacts',
  driverDockGroups: 'api/driver-dock-groups',
  businessUnits: 'api/business-units',
  dockGroups: 'api/dock-groups',
  taskMessagesNotifications: 'api/task-messages-notifications',
  clients: 'api/clients',
  locations: 'api/locations',
  imageCaptures: 'api/image-captures',
};
